module.exports = __webpack_public_path__ + "img/考核评价.128905e2.svg";